(function (root) {
 'use strict';
 // A paid item can share its variant with a gift, including cloth bundle components.
 // Only an explicit gift marker excludes a line from qualifying merchandise spend.
 const giftItem = (item) => Boolean(item.properties?.__section_store_card_reward_free_gift || (item.properties?._nc_gift && item.properties._nc_gift !== 'false'));
 function giftSpend(cart) {
   return (cart.items || []).filter(i => !giftItem(i)).reduce((s,i) => s + Number(i.original_line_price ?? i.final_line_price ?? 0),0);
 }
 function paidSpend(cart, ids = []) {
   // final_line_price includes product discounts; allocate order discounts by paid line value.
   const all = (cart.items || []).reduce((s, i) => s + Number(i.final_line_price || 0), 0);
   const paid = (cart.items || []).filter(i => !giftItem(i, ids)).reduce((s, i) => s + Number(i.final_line_price || 0), 0);
   const orderDiscount = (cart.cart_level_discount_applications || []).reduce((s, d) => s + Number(d.total_allocated_amount || 0), 0);
   return Math.max(0, paid - (all ? Math.round(orderDiscount * paid / all) : 0));
 }
 function shippingQualified(spend, threshold, country, currency) {
   return threshold !== null && (spend >= threshold || (country === 'AU' && currency === 'AUD' && (spend === 6000 || spend === 6001)));
 }
 function state(spend, thresholds, shippingOverride, gross = spend) {
   const unlocked = thresholds.map((t,i) => (i === 0 ? spend : gross) >= t);
   if (typeof shippingOverride === 'boolean') unlocked[0] = shippingOverride;
   const next = unlocked.indexOf(false);
   let fill = 100;
   if (next === 0) fill = 0;
   else if (next > 0) fill = ((next - 1) + (gross - thresholds[next - 1]) / (thresholds[next] - thresholds[next - 1])) / (thresholds.length - 1) * 100;
   return {unlocked, next, remaining: next < 0 ? 0 : Math.max(0, thresholds[next] - (next === 0 ? spend : gross)), fill: Math.min(100, Math.max(0, fill))};
 }
 const api = {giftItem, paidSpend, giftSpend, state, shippingQualified};
 if (typeof module !== 'undefined' && module.exports) module.exports = api;
 root.NCBFRewardRules = api;
})(typeof window !== 'undefined' ? window : globalThis);
